import React, { useRef, useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import useApi from '../../api/useApi';
import Moment from 'react-moment';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const Traders = () => {
    const navigate = useNavigate();
    const [modalVisible, setModalVisible] = useState(false);
    const [editTrader, setEditTrader] = useState({});
    const [gridApi, setGridApi] = useState(null);
    const api = useApi();
    const [registeredTraders, setRegisteredTraders] = useState([]);
    const gridRef = useRef();
    //const columns = [
    //    { Header: 'User Code', accessor: 'userCode', className: 'text-center' },
    //    { Header: 'Bidder Name', accessor: 'bidderName', className: 'text-center' },
    //    { Header: 'Mobile Number', accessor: 'mobileNo', className: 'text-center' },
    //    { Header: 'Licence Number', accessor: 'licenceNumber', className: 'text-center' },
    //    { Header: 'RC Number', accessor: 'rcNumber', className: 'text-center' },
    //    { Header: 'CST Number', accessor: 'cstNumber', className: 'text-center' },
    //    { Header: 'VAT/GST Number', accessor: 'vatgstNumber', className: 'text-center' },
    //    { Header: 'Email Id', accessor: 'emailId', className: 'text-center' },
    //    { Header: 'Status', accessor: 'status', className: 'text-center' },
    //    { Header: 'Action', accessor: row => <button className="btn ripple btn-outline-primary text-nowrap btn-sm btn-rounded mg-r-5" onClick={() => viewTraderDetails(row.traderId)}> <i className="fe fe-edit-2"></i> Detail</button> },
    //];

    const linkRenderer = (props) => {
        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
        return (
            <span>
                <span role="button" className="custom-link" onClick={() => viewTraderDetails(props.data.traderId)}>{cellValue}</span>
            </span>
        );
    };
    const statusRenderer = (props) => {
        const cellValue = (props.valueFormatted ? props.valueFormatted : props.value) === "1" ? 'Enabled' : 'Disabled';

        return (
            <span>
                <span role="button" className="custom-link" onClick={() => editStatus(props.data)}>{cellValue}</span>
            </span>
        );
    };

    const columns = [
        { headerName: '#', field: 'bidNo', headerClass: 'text-center', cellClass: 'text-center', cellRenderer: (props) => { return <span>{props.rowIndex + 1}</span> }, width: 40 },
        { headerName: 'User Code', field: 'userCode', headerClass: 'text-center', cellClass: 'text-center', width: 60 },
        { headerName: 'Bidder Name', field: 'bidderName', cellRenderer: linkRenderer, width: 250 },
        { headerName: 'Mobile Number', field: 'mobileNo', headerClass: 'text-center', cellClass: 'text-center', width: 100 },
        { headerName: 'Licence Number', field: 'licenceNumber', headerClass: 'text-center', cellClass: 'text-center', width: 140 },
        { headerName: 'RC Number', field: 'rcNumber', headerClass: 'text-center', cellClass: 'text-center', width: 140 },
        { headerName: 'CST Number', field: 'cstNumber', headerClass: 'text-center', cellClass: 'text-center', width: 140 },
        { headerName: 'VAT/GST Number', field: 'vatgstNumber', headerClass: 'text-center', cellClass: 'text-center', width: 140 },
        { headerName: 'Email Id', field: 'emailId', width: 180 },
        { headerName: 'Status', field: 'status', headerClass: 'text-center', cellClass: 'text-center', width: 100, cellRenderer: statusRenderer },
    ];

    const gridOptions = {
        defaultColDef: {
            wrapHeaderText: true,
            autoHeaderHeight: true,
        },
        columnDefs: columns,
        rowClass: 'custom-grid-font',
        getRowClass: params => {
            if (params.node.rowIndex % 2 === 0) {
                return 'bg-gray-50-i';
            }
        }
    };


    const loadTraders = async () => {
        try {
            const lotData = await api.getTraders();
            setRegisteredTraders(lotData);
        } catch (error) {
            alert('Unable to fetch traders data.');
        }
    };

    useEffect(() => {
        loadTraders();
    }, []);

    const handleClose = () => {
        setModalVisible(false);
    };
    const viewTraderDetails = (traderId) => {
        navigate(`/traderDetail/${traderId}`);
    };

    const editStatus = (trader) => {
        setEditTrader(trader);
        setModalVisible(true);
    }

    const handleRadioChange = (e) => {
        setEditTrader({
            ...editTrader,
            status: parseInt(e.target.value),
        });
    };

    const onUpdateTraderStatus = async () => {
        const params = {
            traderId: editTrader.traderId,
            status: editTrader.status
        };

        await api.updateTraderStatus(params).then((response) => {
            if (response.success) {
                loadTraders();
                setModalVisible(false);
                alert(response.message);
            }
            else
                alert(response.message);

        }).catch((error) => {
            console.error('Error saving trader:', error);
        });
    };

    const onFilterTextBoxChanged = useCallback(() => {
        gridRef.current.api.setGridOption(
            "quickFilterText",
            document.getElementById("filter-text-box").value,
        );
    }, []);

    const onGridReady = (params) => {
        setGridApi(params.api);
    };

    const exportToExcel = async (e) => {
        e.preventDefault();
        try {
            const { fileName, fileData } = await api.downloadReport('Traders', 0);
            const url = window.URL.createObjectURL(new Blob([fileData]), { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            alert('Unable to download file.');
        }
    }
     

    return (
        <div>
            <div className="inner-body">
                <div className="page-header">
                    <div>
                        <h2 className="main-content-title tx-24 mg-b-5">Traders</h2>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a className="custom-link" onClick={() => navigate('/home')}>Home</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Traders</li>
                        </ol>
                    </div>
                    <div className="d-flex">
                        <div className="justify-content-center">
                            <button type="button" className="btn btn-primary my-2 btn-icon-text btn-sm" onClick={() => viewTraderDetails(0)}>
                                <i className="fe fe-edit me-2"></i> Add New Trader
                            </button>
                            <button className="btn ripple btn-outline-primary pd-x-10 mg-l-5 mg-r-5  btn-sm" type="button" onClick={exportToExcel}>
                                <i class="ti ti-import me-2"></i>Export to Excel
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row row-sm">
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
                        <div className="card custom-card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between mg-b-8">
                                    <div>
                                         
                                    </div>
                                    <div>
                                        <input type="text" className="form-control" id="filter-text-box" onChange={onFilterTextBoxChanged}  placeholder="type to filter"></input>
                                    </div>
                                </div>
                                <div
                                    style={{ height: 500 }}
                                    className={
                                        "ag-theme-alpine"
                                    }
                                >
                                    <AgGridReact ref={gridRef} gridOptions={gridOptions}
                                        onGridReady={onGridReady}
                                        rowData={registeredTraders}
                                    /></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={modalVisible} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Add/Edit Auction</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        Trader Name
                        <input className="form-control" disabled placeholder="User Name" type="text" value={editTrader.bidderName} />
                    </div>

                    <div className="form-group">
                        Status
                        <div className="mg-l-20 d-flex">
                            <div className="mg-r-50">
                                <input name="status" type="radio" value="1" className="form-check-input" onChange={handleRadioChange} checked={editTrader.status === 1} />
                                <label title="" className="form-check-label">Enabled</label>
                            </div>
                            <div>
                                <input name="status" type="radio" value="0" className="form-check-input" onChange={handleRadioChange} checked={editTrader.status === 0} />
                                <label title="" className="form-check-label">Disabled</label>
                            </div>
                        </div>
                    </div>

                    <div className="mg-t-20">
                        <button className="btn ripple btn-primary pd-x-30 mg-r-5" type="button" onClick={onUpdateTraderStatus}>
                            Save
                        </button>
                        <button className="btn ripple btn-light pd-x-30" onClick={handleClose}>
                            Close
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default Traders;